<script>
  import Header from './header.svelte'
  import Dropdown from '@components/general/dropdown.svelte'
  import { ListChecks, CheckCheck, X } from 'lucide-svelte'

  let { selection } = $props()

</script>

<Header width="6%" align="center">
  <Dropdown width="16rem" align="start" itemSize="sm" buttonProps={{ variant: "naked", Icon: ListChecks, class: "min-w-0 gap-1" }} closeOnSelect>
    {#snippet contents(item)}
      {@render item({ text: "Select this page", icon: ListChecks, onSelect: () => selection.selectPage(), disabled: selection.pageOnlySelected })}
      {@render item({ text: `Select all ${selection.totalCount} results`, icon: CheckCheck, onSelect: () => selection.selectCollection(), disabled: selection.allSelected })}
      {@render item({ text: "Clear selection", icon: X, onSelect: () => selection.clear(), disabled: selection.empty })}
    {/snippet}
  </Dropdown>
</Header>